export default "<div id=\"content\">\r\n  Assessments will go here...\r\n</div>\r\n\r\n\r\n"